import { POST_LOGIN, SET_USER, LOGOUT } from "../actions/actionLogin";

const initialState = {
    loginId: localStorage.getItem('userId') || null,
    isAuthenticated: localStorage.getItem('isAuthenticated') === 'true' ,
    error: null,
    user: JSON.parse(localStorage.getItem('userData')) || {}
}

export default function reducerLogin(state = initialState, action){
    switch (action.type) {        
        case POST_LOGIN:
            console.log(action.payload);            
            return {
                ...state,
                loginId: action.payload.loginId,
                isAuthenticated: true,
                error: null,
                user: action.payload             
            }            
        case SET_USER:
            return {
                ...state,
                user: action.payload,
                isAuthenticated: true
            }
        case LOGOUT:
            localStorage.clear()            
            return {
                initialState,
                isAuthenticated: false,         
            }                                        
        default:
            return state;
    }
}